import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "boxicons";
import { RESEARCH_TYPE } from "./app/utils/consts";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { logEvent } from "./app/utils/analytics";
import { fetchLanguage } from "./store/actions/languageActions";
import Signin from "./app/Signin";
import CreateNewAccount from "./app/CreateNewAccount";
import SelectUserAccount from "./app/SelectUserAccount";
import Dashboard from "./app/Dashboard";
import ChangePassword from "./app/ChangePassword";
import ForgotPassword from "./app/ForgotPassword";

import BasicDetails from "./app/BasicDetails";
import AboutMe from "./app/AboutMe";
import AddALSFRS from "./app/screens/add-forms/ALSFRS";
import AddCpibForm from "./app/screens/add-forms/CpibForm";
import AddAresScore from "./app/screens/add-forms/AresScore";
import AddRoads from "./app/screens/add-forms/Roads";
import PersonalDataViewer from "./app/PersonalDataViewer";

// update demographics pages
import PersonalInfo from "./app/screens/about-me/PersonalInfo";
import GenderInfo from "./app/screens/about-me/GenderInfo";
import LanguageEducation from "./app/screens/about-me/LanguageEducation";
import PhysicalCharachteristics from "./app/screens/about-me/PhysicalCharachteristics";
import MedicalHistory from "./app/screens/about-me/MedicalHistory";
import MedicalConditions from "./app/screens/about-me/MedicalConditions";
import FamilyHistory from "./app/screens/about-me/FamilyHistory";
import AdditionalHealthInfo from "./app/screens/about-me/AdditionalHealthInfo";
import RecentHealthEvents from "./app/screens/about-me/RecentHealthEvents";
import EcasSymptomOnset from "./app/screens/about-me/EcasSymptomOnset";
import GeneticTestingAndGeneMutation from "./app/screens/about-me/GeneticTestingAndGeneMutation";
import ViewEcasFormA from "./app/screens/dataViewer/ecasViewForms/ecasFormA/Main";
import ViewEcasFormB from "./app/screens/dataViewer/ecasViewForms/ecasFormB/Main";
import ViewEcasFormC from "./app/screens/dataViewer/ecasViewForms/ecasFormC/Main";
import AutoLogin from "./app/AutoLogin";
import ConsentForm from "./app/ConsentForm";
import ViewConsentForm from "./app/ViewConsentForm";
import UploadPDFForGeneticConfirmation from "./app/UploadPDFForGeneticConfirmation";
import AddPhysicalEcasForm from "./app/AddPhysicalEcasForm";
import VoiceRecording from "./app/screens/speech/VoiceRecording";
import UpdateAlsfrsAndRoads from "./app/screens/speech/UpdateAlsfrsAndRoads";
import UpdateAlsFrs from "./app/screens/speech/alsfrsRoadsComponents/AlsFrsr";
import UpdateRoads from "./app/screens/speech/alsfrsRoadsComponents/Roads";
import ThankYou from "./app/screens/speech/alsfrsRoadsComponents/ThankYou";

// speech study demographics about me
import SpeechNonAlsUsers from "./app/screens/speech/aboutMe/NonAlsUsers";
import SpeechDateOfBirth from "./app/screens/speech/aboutMe/DateOfBirth";
import SpeechEthnicityRace from "./app/screens/speech/aboutMe/EthnicityRace";
import SpeechAllergiesAndPrescriptions from "./app/screens/speech/aboutMe/AllergiesAndPrescriptions";
import SpeechHandnessSmokingHistory from "./app/screens/speech/aboutMe/HandnessSmokingHistory";
import SpeechMedicalHistory from "./app/screens/speech/aboutMe/MedicalHistory";
import SpeechFamilyHistory from "./app/screens/speech/aboutMe/FamilyHistory";
import SpeechLanguageAndEducation from "./app/screens/speech/aboutMe/LanguageAndEducation";
import SpeechDiagnosis from "./app/screens/speech/aboutMe/Diagnosis";
import SpeechSymptomOnset from "./app/screens/speech/aboutMe/SymptomOnset";

// le study demographics about me 1
import LESymptomOnset from "./app/screens/about-me/LESymptomOnset";

import Profile from "./app/Profile";
import DownloadEverythingAlsApp from "./app/screens/leStudy/DownloadEverythingAlsApp";
import PrintReportPage from "./app/PrintReportPage";

// ecas study demographics about me
import EcasStudyAlsfrsrScore from "./app/screens/ecasStudy/Alsfrsr";
import NewECASLiveSession from "./app/screens/ecasStudy/NewECASLiveSession";
import AddEcasStudyAlsfrsrScore from "./app/screens/ecasStudy/AddAlsfrsr";
import AlsfrsUploadForm from "./app/screens/ecasStudy/AlsfrsUploadForm";

// Routes titles for page titles
const ROUTE_TITLES = {
  "/": "Sign In",
  "/create-new-account": "Create Account",
  "/select-user-account": "Select Account",
  "/dashboard": "Dashboard",
  "/change-password": "Change Password",
  "/forgot-password": "Forgot Password",
  "/basic-details": "Basic Details",
  "/about-me": "About Me",
  "/add-alsfrs": "Add ALSFRS",
  "/add-cpibform": "Add CPIB Form",
  "/add-ares-score": "Add ARES Score",
  "/add-roads": "Add ROADS",
  "/my-personal-data-viewer": "Personal Data Viewer",
  "/ecas-live-session": "ECAS Live Session",
  "/personal-details": "Personal Details",
  "/gender-race-ethnicity-details": "Gender, Race & Ethnicity",
  "/language-education-occupation-details": "Language, Education & Occupation",
  "/physical-charachteristics": "Physical Characteristics",
  "/medical-history": "Medical History",
  "/medical-condition": "Medical Conditions",
  "/family-history": "Family History",
  "/additional-health-info": "Additional Health Info",
  "/recent-health-events": "Recent Health Events",
  "/ecas-symptom-onset": "Symptom Onset",
  "/le-symptom-onset": "Symptom Onset",
  "/genetic-testing-and-gene-mutation": "Genetic Testing & Gene Mutation",
  "/ecas-form-view-a": "ECAS Form A",
  "/ecas-form-view-b": "ECAS Form B",
  "/ecas-form-view-c": "ECAS Form C",
  "/auto_login": "Auto Login",
  "/consent-form": "Consent Form",
  "/view-consent-form": "View Consent Form",
  "/upload-pdf-for-genetic-confirmation": "Upload Genetic Confirmation PDF",
  "/add-physical-ecas-form": "Add Physical ECAS Form",
  "/voice-recording-acknowledgment": "Voice Recording",
  "/update-alsfrs-and-roads": "Update ALSFRS & ROADS",
  "/update-alsfrs": "Update ALSFRS",
  "/update-roads": "Update ROADS",
  "/thank-you": "Thank You",
  "/profile": "Profile",
  "/speech-non-als-users": "Speech - Non ALS Users",
  "/speech-date-of-birth": "Speech - Date of Birth",
  "/speech-ethnicity-and-race": "Speech - Ethnicity & Race",
  "/speech-language-and-education": "Speech - Language & Education",
  "/speech-handness-and-smoking-history": "Speech - Handedness & Smoking History",
  "/speech-allergies-and-prescriptions": "Speech - Allergies & Prescriptions",
  "/speech-medical-history": "Speech - Medical History",
  "/speech-family-history": "Speech - Family History",
  "/speech-diagnosis": "Speech - Diagnosis",
  "/speech-symptom-onset": "Speech - Symptom Onset",
  "/download-everything-als-app": "Download Everything ALS App",
  "/ecas-alsfrs-r": "ECAS ALSFRS-R Score",
  "/add-ecas-alsfrs-r-score": "Add ECAS ALSFRS-R Score",
  "/upload-ecas-alsfrs-r-form": "Upload ECAS ALSFRS-R Form",
  "/print-report": "Print Report",
};

let _lastTrackedPath = null;

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (_lastTrackedPath === location.pathname) return;
    _lastTrackedPath = location.pathname;
    const pageTitle = ROUTE_TITLES[location.pathname] || "EALS Patient Portal";
    document.title = `${pageTitle} | EALS Patient Portal`;
    logEvent("page_view", { page_path: location.pathname });
  }, [location.pathname]);
  return null;
}

function App() {
  const dispatch = useDispatch();
  const { language, isLanguageLoaded } = useSelector((state) => state.language);
  useEffect(() => {
    dispatch(fetchLanguage());
  }, [dispatch]);
  return (
    <div>
      <Router>
        <RouteTracker />
        <Routes>
          <Route path="/" exact element={<Signin />} />
          {RESEARCH_TYPE == "modality.ai" ||
          RESEARCH_TYPE == "ECAS Study" ||
          RESEARCH_TYPE == "LE Study" ? (
            <Route
              path="/create-new-account"
              exact
              element={<CreateNewAccount />}
            />
          ) : (
            <></>
          )}
          <Route
            path="/select-user-account"
            exact
            element={<SelectUserAccount />}
          />
          <Route
            path="/dashboard"
            exact
            element={<Dashboard language={language} />}
          />
          <Route
            path="/change-password"
            exact
            element={<ChangePassword language={language} />}
          />
          <Route path="/forgot-password" exact element={<ForgotPassword />} />

          <Route
            path="/basic-details"
            exact
            element={<BasicDetails language={language} />}
          />
          <Route
            path="/about-me"
            exact
            element={<AboutMe language={language} />}
          />
          <Route path="/add-alsfrs" exact element={<AddALSFRS />} />
          <Route path="/add-cpibform" exact element={<AddCpibForm />} />
          <Route path="/add-ares-score" exact element={<AddAresScore />} />
          <Route path="/add-roads" exact element={<AddRoads />} />

          <Route
            path="/my-personal-data-viewer"
            exact
            element={<PersonalDataViewer language={language} />}
          />
          {RESEARCH_TYPE == "ECAS Study" && (
            <Route
              path="/ecas-live-session"
              exact
              element={<NewECASLiveSession />}
            />
          )}

          <Route
            path="/personal-details"
            exact
            element={<PersonalInfo language={language} />}
          />
          <Route
            path="/gender-race-ethnicity-details"
            exact
            element={<GenderInfo language={language} />}
          />
          <Route
            path="/language-education-occupation-details"
            exact
            element={<LanguageEducation language={language} />}
          />
          <Route
            path="/physical-charachteristics"
            exact
            element={<PhysicalCharachteristics language={language} />}
          />
          <Route
            path="/medical-history"
            exact
            element={<MedicalHistory language={language} />}
          />
          <Route
            path="/medical-condition"
            exact
            element={<MedicalConditions />}
          />
          <Route path="/family-history" exact element={<FamilyHistory />} />
          <Route
            path="/additional-health-info"
            exact
            element={<AdditionalHealthInfo />}
          />
          <Route
            path="/recent-health-events"
            exact
            element={<RecentHealthEvents />}
          />
          <Route
            path="/ecas-symptom-onset"
            exact
            element={<EcasSymptomOnset />}
          />
          <Route
            path="/le-symptom-onset"
            exact
            element={<LESymptomOnset language={language} />}
          />
          <Route
            path="/genetic-testing-and-gene-mutation"
            exact
            element={<GeneticTestingAndGeneMutation />}
          />
          <Route path="/ecas-form-view-a" exact element={<ViewEcasFormA />} />
          <Route path="/ecas-form-view-b" exact element={<ViewEcasFormB />} />
          <Route path="/ecas-form-view-c" exact element={<ViewEcasFormC />} />
          <Route path="/auto_login" exact element={<AutoLogin />} />
          {isLanguageLoaded && (
            <Route
              path="/consent-form"
              exact
              element={<ConsentForm language={language} />}
            />
          )}
          <Route
            path="/view-consent-form"
            exact
            element={<ViewConsentForm language={language} />}
          />
          <Route
            path="/upload-pdf-for-genetic-confirmation"
            exact
            element={<UploadPDFForGeneticConfirmation />}
          />
          <Route
            path="/add-physical-ecas-form"
            exact
            element={<AddPhysicalEcasForm />}
          />

          <Route
            path="/voice-recording-acknowledgment"
            exact
            element={<VoiceRecording />}
          />
          <Route
            path="/update-alsfrs-and-roads"
            exact
            element={<UpdateAlsfrsAndRoads />}
          />
          <Route path="/update-alsfrs" exact element={<UpdateAlsFrs />} />
          <Route path="/update-roads" exact element={<UpdateRoads />} />
          <Route path="/thank-you" exact element={<ThankYou />} />
          <Route path="/profile" exact element={<Profile />} />

          {/* Speech demographics  */}
          <Route
            path="/speech-non-als-users"
            exact
            element={<SpeechNonAlsUsers />}
          />
          <Route
            path="/speech-date-of-birth"
            exact
            element={<SpeechDateOfBirth />}
          />
          <Route
            path="/speech-ethnicity-and-race"
            exact
            element={<SpeechEthnicityRace />}
          />
          <Route
            path="/speech-language-and-education"
            exact
            element={<SpeechLanguageAndEducation />}
          />
          <Route
            path="/speech-handness-and-smoking-history"
            exact
            element={<SpeechHandnessSmokingHistory />}
          />
          <Route
            path="/speech-allergies-and-prescriptions"
            exact
            element={<SpeechAllergiesAndPrescriptions />}
          />
          <Route
            path="/speech-medical-history"
            exact
            element={<SpeechMedicalHistory />}
          />
          <Route
            path="/speech-family-history"
            exact
            element={<SpeechFamilyHistory />}
          />
          <Route path="/speech-diagnosis" exact element={<SpeechDiagnosis />} />
          <Route
            path="/speech-symptom-onset"
            exact
            element={<SpeechSymptomOnset />}
          />
          {RESEARCH_TYPE == "ECAS Study" && (
            <>
              <Route path="/ecas-alsfrs-r" exact element={<EcasStudyAlsfrsrScore />} />
              <Route path="/add-ecas-alsfrs-r-score" exact element={<AddEcasStudyAlsfrsrScore />} />
              <Route path="/upload-ecas-alsfrs-r-form" exact element={<AlsfrsUploadForm />} />
            </>
          )}
          <Route
            path="/download-everything-als-app"
            exact
            element={<DownloadEverythingAlsApp language={language} />}
          />
          <Route path="/print-report" exact element={<PrintReportPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
